// eslint-disable-next-line import/no-extraneous-dependencies
import { Module } from 'vuex';

interface ABTestMoudleType {
    /**
     * @zh 从接口中获取实验参数
     */
    abTestParams?: {
        notification_check?: 'true' | 'false';

        /**
         * @zh 每刷从接口获取的 feed 数量
         */
        FetchFeedListDefaultCount?: number;

        /**
         * @zh 保留上滑的 video 数量
         */
        HoldPreVideoCount?: number;

        /**
         * @zh 下滑 feed 最小剩余量
         */
        NextFeedListMinCount?: number;

        /**
         * @zh 下滑预加载的最大数量
         */
        NextPreLoadVideoCount?: number;
    };
}

export const defaultFeedListPreLoadParams = {
    FetchFeedListDefaultCount: 4,
    HoldPreVideoCount: 1,
    NextFeedListMinCount: 1,
    NextPreLoadVideoCount: 2,
};

const defaultABTestModule: ABTestMoudleType = {
    abTestParams: {
        notification_check: undefined,
        ...defaultFeedListPreLoadParams,
    },
};

export const abTestModule: Module<ABTestMoudleType, any> = {
    namespaced: true,
    state: defaultABTestModule,
    actions: {},
    mutations: {
        setABTestParams(state, data: ABTestMoudleType['abTestParams']) {
            state.abTestParams = {
                ...(state.abTestParams || {}),
                ...(data || {}),
            };
        },
    },
};
